module.exports = "/static/assets/31f212395be821de9307a65cb55829cc.png";